import { Labels } from '../../shared-components/global/labels';

Labels.set('ui-table-expandable', 'expandRow', 'Expand row');
Labels.set('ui-table-expandable', 'collapseRow', 'Collapse row');
Labels.set('ui-table-expandable', 'actions', 'Actions');
